module.exports = __webpack_public_path__ + "img/company-logo.62a4ca36.png";